import Circle, { type CircleProps } from './circle';

export { sizes as circleSizes } from './style';
export { Circle, CircleProps };

export default Circle;
